import get from 'lodash/get';
import { SlotType } from '@rome/response/page/v4/SlotType';
import * as actions from 'actions/pageActionsV4';
const { PAGE_DATA_ACTIONS } = actions;
import * as sectionActions from 'actions/sectionActions';
const { SECTION_ACTIONS } = sectionActions;
import { createPageTree } from '../PageDataReducers/pageDataReducer';
import { VisualState } from './sectionUtils';
const getAllChildLogicalSlots = (slotId, pageTree) => {
    const data = pageTree[slotId];
    const slotIdArray = [];
    data.forEach(slot => {
        if (slot.slotType === SlotType.LOGICAL && slot.id !== undefined) {
            slotIdArray.push(...[slot.id, ...getAllChildLogicalSlots(slot.id, pageTree)]);
        }
    });
    return slotIdArray;
};
const getSectionInfo = (pageTree, parentSectionId, isLoggedIn) => {
    let sectionMetaData = [];
    const data = pageTree[parentSectionId];
    // If user is logged in then we move to second section other-wise first section i.e login tab
    // Storing index instead of slotId - because on page refresh we can get new slotId's if the
    // postion changes, hence index is more reliable as compared to slotId
    const activeIndex = isLoggedIn ? 1 : 0;
    data.forEach((slot, index) => {
        if (slot.id !== undefined) {
            const visualState = activeIndex > index ? VisualState.COMPLETE : VisualState.INCOMPLETE;
            sectionMetaData.push({
                childLogicalSlotIds: [slot.id, ...getAllChildLogicalSlots(slot.id, pageTree)],
                visualState
            });
        }
    });
    return {
        activeIndex,
        sectionMetaData
    };
};
// merging old and new sectionInfo if we get new slotIds in the updated response then slotIds will also get update
const mergeSectionData = (newState, oldState) => {
    const { sectionMetaData: oldSectionMetaData, activeIndex: oldActiveIndex } = oldState;
    const { sectionMetaData: newSectionMetaData } = newState;
    // 1. When page load for the first time or we do hard reload all the initial data is lost and we
    // always go for the newState created from pageResponse.
    // 2. When we do oneActionView Call at that time we maintain oldState with new LogicalSlotIds if any
    // from the pageResponse.
    if (oldSectionMetaData.length === 0) {
        return newState;
    }
    return {
        activeIndex: oldActiveIndex,
        sectionMetaData: newSectionMetaData.map((metaData, index) => {
            return Object.assign(Object.assign({}, metaData), { visualState: oldSectionMetaData[index].visualState });
        })
    };
};
const defaultState = {
    activeIndex: 0,
    sectionMetaData: []
};
export default function (state = defaultState, action) {
    const slots = get(action, 'data.slots');
    const isLoggedIn = get(action, ['data', 'pageData', 'pageContext', 'loggedIn']) || false;
    switch (action.type) {
        case PAGE_DATA_ACTIONS.LOAD_MORE_CONTENT_SUCCESS:
        case PAGE_DATA_ACTIONS.SUCCESS: {
            if (!slots)
                return state;
            const { pageTree, parentSectionId } = createPageTree(slots);
            if (!parentSectionId)
                return state;
            const sectionSlotInfo = getSectionInfo(pageTree, parentSectionId, isLoggedIn);
            return Object.assign(Object.assign({}, state), mergeSectionData(sectionSlotInfo, state));
        }
        case SECTION_ACTIONS.CHANGE_SECTION_TAB: {
            const { sectionIndex } = action;
            // clicking on change of a section will make itself and section below it as incomplete
            return Object.assign(Object.assign({}, state), { activeIndex: sectionIndex, sectionMetaData: state.sectionMetaData.map((sectionData, index) => {
                    return Object.assign(Object.assign({}, sectionData), { visualState: index >= sectionIndex ? VisualState.INCOMPLETE : sectionData.visualState });
                }) });
        }
        case SECTION_ACTIONS.CONTINUE_TO_NEXT_SECTION_TAB: {
            // clicking on continue to next section will make itself as complete and will
            // increment active index by 1 only when that section exists.
            const currentActiveIndex = state.activeIndex;
            if (currentActiveIndex + 1 > state.sectionMetaData.length - 1) {
                return state;
            }
            const sectionMetaData = [...state.sectionMetaData];
            sectionMetaData[currentActiveIndex].visualState = VisualState.COMPLETE;
            return Object.assign(Object.assign({}, state), { activeIndex: currentActiveIndex + 1, sectionMetaData });
        }
        default:
            return state;
    }
}
